<template>
  <v-container class="pa-md-3 pa-1" fluid>
    <v-sheet color="transparent">
      <div class="text-center pt-1 pt-md-5 pb-5 pl-3 pr-3" v-bind:style="brandedTextClass">
        <h1 class="display-1">{{ this.$store.state.selectedActivity.name }}</h1>
        <p v-if="$store.state.selectedActivity.description" class="mb-1" style="opacity: 0.87">
          {{
            $vuetify.breakpoint.smAndUp
              ? $store.state.selectedActivity.description
              : $store.state.selectedActivity.description.substr(0, 50) + "..."
          }}
        </p>
        <v-img v-if="teaserImg" class="my-2" :src="teaserImg" contain max-height="40vh"></v-img>
        <div style="opacity: 0.87" v-if="eventCountdown && eventCountdown.asSeconds() > 0">
          <span>{{ $t("participant.main.starts") }}</span>
          <span>
            {{ parseStartDate }}
          </span>
          <span> {{ $t("participant.main.at") }} </span>
          <span>
            {{ parseStartTime }}
          </span>
        </div>
        <div style="opacity: 0.87" v-if="onGoing || ended">
          {{ parseStartDate }}
          <span> {{ $t("participant.main.at") }} </span>
          <span>
            {{ parseStartTime }}
          </span>
        </div>
        <p class="display-1 font-weight-bold mb-1" v-if="eventCountdown">
          <span v-if="eventCountdown.asHours() >= 1">{{ eventCountdown.hours() + eventCountdown.days() * 24 }}h </span>
          <span v-if="eventCountdown.asMinutes() >= 1">{{ pad(eventCountdown.minutes()) }}m </span>
          <span v-if="eventCountdown.asSeconds() >= 1">{{ eventCountdown.seconds() }}s</span>
          <v-btn
            @click="testVideo()"
            icon
            color="primary"
            large
            class="ml-3"
            v-if="(eventCountdown.asSeconds() > 3 || ended) && $store.state.me && $store.state.me.appAdmin"
            title="Reduce countdown (Test mode)"
          >
            <v-icon>mdi-clock-fast</v-icon>
          </v-btn>
        </p>
        <div v-if="onGoing">
          <p class="display-1 font-weight-bold">
            {{ $t("participant.main.started") }}
          </p>
          <p class="small">{{ $t("participant.main.startedHelp") }}</p>
        </div>
        <div v-if="ended">
          <p class="display-1 font-weight-bold">
            {{ $t("participant.main.ended") }}
          </p>
        </div>
        <div class="text-center mt-5 mb-5" v-if="ended && $store.state.selectedActivity.enablePostEventForm">
          <p class="body-2 mb-3" v-html="$t('participant.main.endedHelp', [wallUrl])"></p>
          <v-btn color="primary" @click="showEndEventChallenge()">
            <v-icon class="mr-1">mdi-wall</v-icon>
            {{ $t("participant.main.endedEvent.completeChallenge") }}
          </v-btn>
        </div>
        <v-dialog
          persistent
          v-if="!joinModel.hasJoined && (!ended || endEventMode) && eventCountdown"
          v-model="dialog"
          width="500"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-if="!endEventMode" v-on="on" :disabled="eventCountdown.asHours() > 1" color="primary" large>
              {{ $t("participant.main.btn.join") }}
            </v-btn>
          </template>

          <v-stepper class="join-stepper pb-0" v-model="joinStep">
            <v-stepper-header>
              <v-stepper-step :complete="joinStep > 1" step="1">
                <div class="d-flex ml-2">{{ $t("participant.join.dialog.step.name") }}</div>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" class="d-flex">
                <div class="d-flex ml-2">{{ $t("participant.join.dialog.step.verify") }}</div>
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-form ref="joinForm" v-model="joinFormValid" v-on:keyup.enter="joinNextStep">
                  <v-text-field
                    v-on:keyup.enter="joinNextStep"
                    :label="$t('participant.join.dialog.firstName')"
                    :rules="[$v.required()]"
                    autocomplete="off"
                    name="firstName"
                    required
                    v-model="joinModel.firstName"
                  ></v-text-field>
                  <v-text-field
                    v-on:keyup.enter="joinNextStep"
                    :label="$t('participant.join.dialog.lastName')"
                    :rules="[$v.required()]"
                    autocomplete="off"
                    name="lastName"
                    required
                    v-model="joinModel.lastName"
                  ></v-text-field>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2">
                <div class="text-md-center">
                  <div v-if="!userNameEditMode">
                    <v-avatar :color="joinAvatar.color" class="ml-md-5">
                      <span class="font-weight-medium" style="color: white">
                        {{ joinAvatar.text }}
                      </span>
                    </v-avatar>
                    <span class="pl-2">
                      {{ joinModel.userName }}
                    </span>
                    <v-btn @click="editUserName()" color="primary" icon text>
                      <v-icon light>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <div v-if="userNameEditMode">
                    <div class="d-flex align-end">
                      <v-text-field
                        :label="$t('participant.join.dialog.userName')"
                        :rules="[$v.required()]"
                        autocomplete="off"
                        name="userName"
                        required
                        v-model="joinModel.newUserName"
                      ></v-text-field>
                      <v-btn class="mb-4" color="primary" icon text @click="saveUserName()">
                        <v-icon light>mdi-check</v-icon>
                      </v-btn>
                      <v-btn class="mb-4" color="secondary" icon text @click="discardUserName()">
                        <v-icon light>mdi-cancel</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <div class="text-center">
                    <v-btn ref="btnJoin" class="mt-4" color="primary" large @click="joinNextStep()">
                      {{ endEventMode ? $t("participant.main.btn.endEvent.join") : $t("participant.main.btn.join") }}
                    </v-btn>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
            <div class="mt-1">
              <v-divider></v-divider>
              <div class="pa-2 float-left" v-if="joinStep > 1">
                <v-btn color="secondary" text @click="joinStep--">
                  {{ $t("participant.join.dialog.back") }}
                </v-btn>
              </div>
              <div class="pa-2 float-right" v-if="joinStep < 2">
                <v-btn color="primary" @click="joinNextStep()">
                  {{ $t("participant.join.dialog.continue") }}
                </v-btn>
                <v-btn color="secondary" text @click="cancelJoin()"> Cancel </v-btn>
              </div>
            </div>
          </v-stepper>
        </v-dialog>
        <div class="text-center" v-if="joinModel.hasJoined">
          {{ $t("participant.join.dialog.joinedAs") }}
          <v-avatar :color="joinAvatar.color" class="ml-5">
            <span class="font-weight-medium" style="color: white">
              {{ joinAvatar.text }}
            </span>
          </v-avatar>
          <span class="pl-2">
            {{ joinModel.userName }}
          </span>
        </div>
      </div>
    </v-sheet>
    <ParticipantPrepareChallengeModal
      :runActivityScheduleEnded="false"
      :runEnded="false"
      :schedule="{}"
      :endEventModes="endEventModes"
      :endEventMode="true"
      @lastClosed="endedEventChallengeFinished()"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import OT from "@opentok/client";
import randomMC from "random-material-color";
import ParticipantPrepareChallengeModal from "./components/participant.prepare.challenge.modal";
import ParticipantModalType from "./components/model/participantModalType";

export default {
  data() {
    return {
      endEventModes: [],
      endEventMode: false,
      testMode: false,
      dialog: null,
      lobbyVideoPlaying: false,
      joinStep: 1,
      joinFormValid: true,
      userNameEditMode: false,
      preStartVideo: null,
      joinModel: {
        firstName: "",
        lastName: "",
        userName: "",
        newUserName: "",
        hasJoined: false,
        registrationId: "",
        accessToken: "",
      },
      joinAvatar: {
        text: null,
        color: null,
        photo: null,
      },
      openTokData: {
        token: null,
        sessionId: null,
        session: null,
        apiKey: null,
      },
      ParticipantModalType,
    };
  },
  components: {
    ParticipantPrepareChallengeModal,
  },
  methods: {
    endedEventChallengeFinished() {
      this.$store.commit("SUCCESS", this.$t("participant.main.endEvent.success"));
      setTimeout(() => (window.location.href = this.wallUrl), 3000);
    },
    async isEnded() {
      if (this.testMode) return false;
      return !!this.eventTime() && -this.eventTime().asMinutes() > this.$store.state.selectedActivity.duration;
    },
    eventTime() {
      if (!this.activityDate || !this.$store.state.serverTime) {
        return null;
      }
      return moment.duration(this.activityDate.diff(this.$store.state.serverTime));
    },
    pad(number) {
      return ("0" + number).slice(-2);
    },
    showEndEventChallenge() {
      if (this.joinModel.hasJoined) {
        this.setEndedEventModes();
      } else {
        this.endEventMode = true;
        this.dialog = true;
      }
    },
    setEndedEventModes() {
      this.endEventModes = [ParticipantModalType.ChallengePerformance, ParticipantModalType.TakeASelfie];
    },
    async joinNextStep() {
      switch (this.joinStep) {
        case 1:
          this.joinModel.firstName = this.joinModel.firstName.trim();
          this.joinModel.lastName = this.joinModel.lastName.trim();
          this.$refs.joinForm.validate();
          if (this.joinFormValid) {
            this.joinModel.userName = `${this.joinModel.firstName} ${this.joinModel.lastName[0].toUpperCase()}.`;
            if (this.joinAvatar.color === null) {
              this.joinAvatar = {
                color: this.getColor(),
                text: this.getInitials(this.joinModel.userName),
              };
            }
            this.joinStep++;
            setTimeout(() => {
              this.$refs.btnJoin.$el.focus();
            }, 300);
          }
          break;
        case 2:
          this.dialog = false;
          this.$store.commit("LOADING", true);
          if (this.userNameEditMode) {
            this.saveUserName();
          }
          await this.setStartDate();
          await this.fetchOpenTokSession();
          this.$store.commit("IS_AUTO_JOINING", false);
          this.$parent.$parent.$parent.setJoinDate(this.joinModel);
          if (this.endEventMode) {
            this.$store.commit("LOADING", false);
            this.setEndedEventModes();
          }
          break;
      }
    },
    cancelJoin() {
      this.dialog = false;
      setTimeout(() => {
        this.joinStep = 1;
        this.joinModel = {
          firstName: this.$route.query.firstName || "",
          lastName: this.$route.query.lastName || "",
        };
        this.$refs.joinForm.resetValidation();
      }, 0);
    },
    editUserName() {
      this.userNameEditMode = true;
      this.joinModel.newUserName = this.joinModel.userName;
    },
    discardUserName() {
      this.userNameEditMode = false;
      this.joinModel.newUserName = "";
    },
    saveUserName() {
      if (this.joinModel.newUserName !== "") {
        this.joinModel.userName = this.joinModel.newUserName;
      }
      this.joinAvatar.text = this.getInitials(this.joinModel.userName);
      this.userNameEditMode = false;
    },
    getColor() {
      return randomMC.getColor({ shades: ["500", "600", "700"] });
    },
    getInitials(userName) {
      if (userName !== null) {
        const userNameParts = userName.split(" ");
        return `${userNameParts[0][0]}${
          userNameParts.length > 1 ? userNameParts[1][0] : userNameParts[0][userNameParts[0].length - 1]
        }`.toUpperCase();
      }
    },
    async fetchOpenTokSession() {
      let url;
      if (this.$store.state.activityTeam) {
        url = `/event/activities/slug/${this.$route.params["activity_slug"]}/getSessionToken/${this.$store.state.activityTeam.slug}`;
      } else {
        url = `/event/activities/slug/${this.$route.params["activity_slug"]}/getSessionToken`;
      }
      const data = await axios.post(url, {
        firstName: this.joinModel.firstName,
        lastName: this.joinModel.lastName,
        username: this.joinModel.userName,
        email: this.joinModel.email,
        registrationId: this.joinModel.registrationId,
        accessToken: this.joinModel.accessToken,
        color: this.joinAvatar.color,
        initials: this.joinAvatar.text,
        userAgent: navigator.userAgent,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        teamCaptain: !!this.$route.query.teamCaptain,
        teamSlug: this.$route.params["team_slug"],
        reconnectParticipantId: this.$store.state.participantId || null,
      });
      if (data.token === null || data.sessionId === null) {
        this.$store.commit("LOADING", false);
        return;
      }
      this.openTokData.token = data.token;
      this.openTokData.sessionId = data.sessionId;
      this.openTokData.apiKey = data.apiKey;
      this.$store.commit("OT_APIKEY", data.apiKey);
      this.$store.commit("SESSION_ID", data.id);
      this.$store.commit("PARTICIPANT_ID", data.participantId);
      this.$store.commit("PARTICIPANT_USERNAME", this.joinModel.userName);
      this.storeReconnectData(this.$route.params["activity_slug"], {
        userAgent: navigator.userAgent,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        teamCaptain: !!this.$route.query.teamCaptain,
        participantId: data.participantId,
        sessionId: data.id,
        ot_apiKey: data.apiKey,
        ot_token: data.token,
        endEventMode: this.endEventMode,
        testMode: this.testMode,
      });
      let _ended = await this.isEnded();
      if (!_ended) {
        this.sessionConnect();
      }
    },
    async getOpenTokSession() {
      const data = await axios.get(`/event/activities/slug/${this.$route.params["activity_slug"]}/getSessionToken`);
      if (data.token === null || data.sessionId === null) {
        this.$store.commit("LOADING", false);
        return;
      }
      this.openTokData.token = data.token;
      this.openTokData.sessionId = data.sessionId;
      this.$store.commit("SESSION_ID", data.id);
      this.$store.commit("PARTICIPANT_ID", data.participantId);
    },
    sessionConnect() {
      this.getParticipantCount();

      this.openTokData.session = OT.initSession(this.openTokData.apiKey, this.openTokData.sessionId);
      this.$store.commit("SESSION_OBJECT", this.openTokData.session);

      this.openTokData.session.on("signal:textChatMessage", (event) => {
        const participantChatLog = document.getElementById("participant-chat-log");
        let chatLogScrollAtTheBottom =
          Math.abs(participantChatLog.scrollTop - (participantChatLog.scrollHeight - participantChatLog.offsetHeight)) <
          10; //bottom or just close

        this.$store.commit("ADD_CHAT_MESSAGE", {
          participantId: event.data.participantId,
          message: event.data.message,
          id: event.data.id,
          initials: event.data.initials,
          color: event.data.color,
          username: event.data.username,
        });

        if (chatLogScrollAtTheBottom)
          setTimeout(() => {
            const participantChatLog = document.getElementById("participant-chat-log");
            participantChatLog.scrollTop = participantChatLog.scrollHeight - participantChatLog.clientHeight;
          }, 200);
      });

      this.openTokData.session.on("signal:textChatMessageRemoval", (event) => {
        this.$store.commit("REMOVE_CHAT_MESSAGE", event.data.id);
      });

      this.openTokData.session.on("signal:updateScheduleDuration", this.updateScheduleDurationHandler);

      this.openTokData.session.on("signal:scheduleUpdated", this.scheduleUpdatedHandler);

      this.openTokData.session.on("signal:videoLinkUpdated", this.videoUpdatedHandler);

      this.initConnectSignal();
      this.initDisconnectSignal();
      this.getTextChatContent();

      this.openTokData.session.connect(this.openTokData.token, (err) => {
        if (err) {
          this.$store.commit("LOADING", false);
        } else {
          this.joinModel.hasJoined = true;
          this.$store.commit("LOADING", false);
          this.$store.commit("ACTIVITY_JOINED");
          if (this.onGoing) {
            this.startActivityStream();
          }
          this.$store.commit("OT_DATA", this.openTokData);
        }
      });
    },
    initConnectSignal() {
      let joinLabel = this.$t("live.activity.participant.joined");
      let severalJoinedLabel = this.$t("live.activity.participant.joinedSeveral");

      this.openTokData.session.on("connectionCreated", (event) => {
        const participant = JSON.parse(event.connection.data);
        this.$store.commit("PARTICIPANT", {
          id: participant.id,
          firstName: participant.firstName,
          lastName: participant.lastName,
          avatarUrl: participant.avatarUrl,
          username: participant.username,
          color: participant.color,
          initials: participant.initials,
        });
        this.$store.commit("NOTIFICATION", {
          type: "participantJoin",
          icon: null,
          who: participant,
          label: joinLabel,
          labelSeveral: severalJoinedLabel,
        });
        this.$store.commit("PARTICIPANTS_TOTAL_COUNT_INCREMENT");
      });
    },
    storeReconnectData(activityId, data) {
      window.sessionStorage.setItem(activityId, JSON.stringify(data));
    },
    initDisconnectSignal() {
      this.openTokData.session.on("connectionDestroyed", (event) => {
        const participant = JSON.parse(event.connection.data);
        this.$store.commit("REMOVE_PARTICIPANT", participant.id);
      });
    },
    async getTextChatContent() {
      const chatMessages = await axios.get(`/event/activities/session/${this.$store.state.sessionId}/textMessage`);
      chatMessages.forEach((item) => {
        this.$store.commit("ADD_CHAT_MESSAGE", {
          participantId: item.participantId,
          message: item.message,
          id: item.id,
          initials: item.participant.initials,
          color: item.participant.color,
          username: item.participant.username,
        });
      });
    },
    startActivityStream() {
      return this.$router.replace({ path: "start", query: this.$route.query });
    },
    testVideo() {
      this.testMode = true;
      this.$store.commit("SET_SERVER_TIME", moment(this.activityDate).subtract(5, "second"));
    },
    async getParticipantCount() {
      const count = await axios.get(
        `/event/activities/session/${this.$store.state.sessionId}/disconnectedParticipantCount`
      );
      await this.$store.commit("PARTICIPANTS_TOTAL_COUNT", count);
    },
    async getParticipantDistance(participantId) {
      const distance = await axios.get(`/event/participants/${participantId}/declaredDistance`);
      await this.$store.commit("DISTANCE_SET", distance);
    },
    setFavicon() {
      var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.$store.state.event.brandingFaviconUrl;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    async reloadParticipant() {
      const data = window.sessionStorage.getItem(this.$route.params["activity_slug"]);
      if (data) {
        this.$store.commit("LOADING", true);
        const objectData = JSON.parse(data);
        const participant = await axios.get(`/event/participants/${objectData.ot_token}`);
        if (!this.$store.state.activityTeam && participant.teamSlug) {
          const team = await this.$axios.get(`/event/${this.$store.state.event.id}/teams/slug/${participant.teamSlug}`);
          this.$store.commit("ADD_TEAM", team);
        }
        this.joinModel.hasJoined = true;
        this.joinModel.firstName = participant.firstName;
        this.joinModel.lastName = participant.lastName;
        this.joinModel.userName = participant.username;
        this.joinModel.registrationId = participant.registrationId;
        this.joinAvatar.color = participant.color;
        this.joinAvatar.text = participant.initials;
        this.openTokData.apiKey = objectData.ot_apiKey;
        this.openTokData.token = objectData.ot_token;
        this.openTokData.sessionId = objectData.sessionId;
        this.$store.commit("OT_APIKEY", objectData.ot_apiKey);
        this.$store.commit("SESSION_ID", objectData.id);
        this.$store.commit("PARTICIPANT_ID", participant.id);
        this.$store.commit(
          "PARTICIPANT_CHALLENGE_DECLARED",
          window.sessionStorage.getItem("challengeDeclared_" + this.$route.params["activity_slug"]) &&
            window.sessionStorage.getItem("challengeDeclared_" + this.$route.params["activity_slug"]) === "true"
        );
        this.$store.commit("PARTICIPANT_USERNAME", this.joinModel.userName);
        this.$store.commit("PARTICIPANT_RECONNECTED", true);
        this.endEventMode = objectData.endEventMode;
        this.testMode = objectData.testMode;
        await this.fetchOpenTokSession();
        this.getParticipantDistance(participant.id);
      }
    },
    updateScheduleDurationHandler(event) {
      this.$store.commit("UPDATE_SCHEDULE_DURATION", {
        currentScheduleActivityId: event.data.currentScheduleActivityId,
        durationSeconds: event.data.durationSeconds,
      });
    },
    scheduleUpdatedHandler(event) {
      this.$store.commit("SCHEDULE_UPDATED", {
        newSchedule: event.data,
      });
    },

    videoUpdatedHandler(event) {
      this.$store.commit("UPDATE_ACTIVITY_VIDEO", event.data);
    },

    async setStartDate() {
      if (!this.$store.state.selectedActivity.initDate) {
        this.$store.commit("UPDATE_ACTIVITY_START_DATE", moment().toISOString());
      }
    },
    async ifLoggedStartStream() {
      let result = false;
      if (this.joinModel.firstName && this.joinModel.lastName && this.joinModel.userName) {
        this.$store.commit("LOADING", true);
        this.joinModel.hasJoined = true;
        this.joinAvatar = {
          color: this.getColor(),
          text: this.getInitials(this.joinModel.userName),
        };
        await this.setStartDate();
        await this.fetchOpenTokSession();
        if (this.endEventMode) {
          this.$store.commit("LOADING", false);
          this.setEndedEventModes();
        }
        this.$parent.$parent.$parent.setJoinDate(this.joinModel);
        result = true;
      }
      return result;
    },
  },
  async mounted() {
    this.$store.commit("IS_AUTO_JOINING", true);
    this.joinModel.firstName = this.$route.query.firstName;
    this.joinModel.lastName = this.$route.query.lastName;
    this.joinModel.userName = this.$route.query.userName;
    this.joinModel.email = this.$route.query.email;
    this.joinModel.registrationId = this.$route.query.registrationId;
    this.joinModel.accessToken = this.$route.query.accessToken;
    if (this.$route.query.accessToken) {
      let registeredParticipant =  await this.$axios.get(`/event/${this.$store.state.event.id}/checkAccess/${this.$route.query.accessToken}`);
      if (registeredParticipant) {
        this.joinModel.firstName = registeredParticipant.firstName;
        this.joinModel.lastName = registeredParticipant.lastName;
        this.dialog = true;
      }
    } else if (this.joinModel.lastName && this.joinModel.firstName) {
      this.dialog = true;
    }
    const started = await this.ifLoggedStartStream();
    if (!started) {
      await this.reloadParticipant();
    }
    this.preStartVideo =
      this.$store.state.selectedActivity.preStartVideo && this.$store.state.selectedActivity.preStartVideo > 0
        ? moment.duration(this.$store.state.selectedActivity.preStartVideo, "second")
        : null;
    this.setFavicon();
  },
  computed: {
    wallUrl() {
      let activity = this.$store.state.selectedActivity;
      if (activity) {
        if (activity.event.brandingWallRedirectUrl) {
          return activity.event.brandingWallRedirectUrl;
        }
        return `${window.location.origin}/wall/${activity.id}`;
      }
      return null;
    },
    activityDate() {
      if (!this.$store.state.selectedActivity.date) {
        return null;
      }
      return moment(this.$store.state.selectedActivity.date);
    },
    teaserImg() {
      if (!this.$store.state.selectedActivity.teaserImageUrl) {
        return null;
      }
      return this.$store.state.selectedActivity.teaserImageUrl;
    },
    eventCountdown() {
      if (!this.activityDate || !this.$store.state.serverTime) {
        return null;
      }
      return moment.duration(this.activityDate.diff(this.$store.state.serverTime));
    },
    onGoing() {
      return (
        !!this.eventCountdown &&
        this.eventCountdown.asSeconds() < 1 &&
        -this.eventCountdown.asMinutes() < this.$store.state.selectedActivity.duration
      );
    },
    ended() {
      return !!this.eventCountdown && -this.eventCountdown.asMinutes() > this.$store.state.selectedActivity.duration;
    },
    parseStartDate() {
      if (!this.activityDate) {
        return "";
      }
      return this.activityDate.locale(this.$i18n.locale).format("D MMMM");
    },
    parseStartTime() {
      if (!this.activityDate) {
        return "";
      }
      return this.activityDate.format("HH:mm");
    },
    brandedTextClass() {
      return {
        color: this.$store.state.event.brandingTextColor,
      };
    },
  },
  watch: {
    eventCountdown: {
      handler(val) {
        if (
          val &&
          this.joinModel.hasJoined &&
          !this.lobbyVideoPlaying &&
          this.preStartVideo &&
          val <= this.preStartVideo
        ) {
          this.startActivityStream();
        }
      },
      immediate: true,
    },
    onGoing: {
      handler(val) {
        if (val && this.joinModel.hasJoined) {
          this.startActivityStream();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
/* unscoped override of stepper display on mobile */
.v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: flex !important;
}

.lobby-video-wrapper {
  height: 40vh !important;

  .video-wrapper {
    padding: 0 !important;
    width: auto;
    height: 40vh;
    position: relative;
    background: #222222;

    .video,
    .video-controls {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40vh;
    }

    .video-controls {
      z-index: 1;
    }
  }
}
</style>
